<p-fieldset legend="Alle Rennen" [toggleable]="true" [collapsed]="true">
    <div *ngIf="!raceDaysloading">
        <ng-container *ngFor="let race of raceDays">
            <p-fieldset
                *ngIf="race.day_real" 
                [legend]="(race.day_real | date: 'dd.MM.yyyy') + ' - ' + race.circuit_name + ' ( ' + race.group_name + ' )'"
                [toggleable]="true"
                [collapsed]="true"
                class="mb-4"
            >
                <div class="flex mb-4">
                    <div>
                        <img src="flag_placeholder.png" [class]="'flag flag-' + race.circuit_icon + ' mr-4'" width="30" />
                    </div>
                    <div class="font-semibold text-xl center-content">
                        {{ race.circuit_name }}
                    </div>
                </div>
                <p-table
                    [value]="race.races ?? []"
                    dataKey="raceresult_id"
                    [rows]="16"
                    [rowHover]="true"
                    [showGridlines]="false"
                    [globalFilterFields]="['name_gt7', 'position_finished', 'car_name', 'best_lap']"
                    responsiveLayout="scroll"
                    size="small"
                >

                        <ng-template #header>
                            <tr>
                                <th pSortableColumn="position_finished">
                                    <div class="pi pi-flag flex justify-between items-center">
                                        <p-sortIcon field="position_finished"></p-sortIcon>
                                    </div>
                                </th>
                                <th style="min-width: 8 rem" pSortableColumn="name_gt7">
                                    <div class="pi pi-user flex justify-between items-center">
                                        Fahrer
                                        <p-sortIcon field="name_gt7"></p-sortIcon>   
                                    </div>
                                </th>
                                <th style="min-width: 8rem" pSortableColumn="car_name">
                                    <div class="pi pi-car flex justify-between items-center">
                                        Auto
                                        <p-sortIcon field="car_name"></p-sortIcon>   
                                    </div>
                                </th>
                                <th>
                                    <div class="pi pi-stopwatch flex justify-between items-center">
                                        Zeit
                                    </div>
                                </th>
                                <th style="min-width: 8rem" pSortableColumn="best_lap">
                                    <div class="pi pi-thumbs-up flex justify-between items-center">
                                        Beste Runde
                                        <p-sortIcon field="best_lap"></p-sortIcon>   
                                    </div>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-player>
                            <tr [routerLink]="['/playerDetails', player.player_id]">
                                <td>
                                    {{ player.position_finished }}
                                </td>
                                <td>
                                    <div *ngIf="isKeyDriver(player.status)" class="pi pi-key mr-2"></div>
                                    <div *ngIf="!isKeyDriver(player.status)" class="pi pi-hourglass mr-2"></div>
                                    <b>{{ player.name_gt7 }}</b> ({{ player.name_psn }})                                    
                                </td>
                                <td>
                                    {{ player.car_name }}
                                </td>
                                <td>
                                    {{ player.final_time }}
                                </td>
                                <td>
                                    {{ player.best_lap }}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template #emptymessage>
                            <tr>
                                <td colspan="8">Keine Renndaten vorhanden</td>
                            </tr>
                        </ng-template>
                        <ng-template #loadingbody>
                            <tr>
                                <td colspan="8">Loading customers data. Please wait.</td>
                            </tr>
                        </ng-template>
                    </p-table> 

                  <div class="mt-4" *ngIf="race.incidents && race.incidents.length > 0">
                    <div class="font-semibold text-l mb-4">Rennvorfälle:</div>
                    <p-table [value]="race.incidents" [size]="'small'" [tableStyle]="{ 'min-width': '14rem' }">
                        <ng-template #body let-data>
                            <tr>
                                <td class="font-semibold">
                                    {{ data.name_gt7 }} ({{ data.name_psn}})
                                </td>
                                <td>{{ data.description }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-fieldset>
        </ng-container>
    </div>
    <div *ngIf="raceDaysloading">Loading...</div>
</p-fieldset>
